<template>
  <div class="feishu">
    <el-row style="margin-top: 10px">
      <el-col :span="24">
<!--         <el-button size="mini" @click="exp('pdf')">导出PDF</el-button>
        <el-button size="mini" @click="exp('word')">导出Word</el-button> -->
        <span>订单号：{{ orderNum }}</span>
      </el-col>
    </el-row>
    <div id="feishu"></div>
<!--     <iframe id="iframe" src="https://ntbolegotq.feishu.cn/wiki/wikcnPGRt6B0cOUZrYntpeZu8Bd?from=from_copylink" style="min-height: calc(100vh - 50px)" width="100%" name="demo" scrolling="auto" sandbox="allow-same-origin allow-scripts"></iframe> -->
  </div>
</template>

<script>
export default {
  name: 'FeiShu',
  data () {
    return {
      orderNum: null,
      myComponent: null,
      url: null
    }
  },
  methods: {
    // exp (type) {
    //   this.myComponent.invoke.export('pdf').then((response) => {
    //     const { code, msg } = response
    //     console.log(code, msg)
    //   })
    // },
    sign () {
      this.$axios.get('/api/admin/fei_shu/auth?url=' + this.$route.query.url + '&oid=' + this.$route.query.oid)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.url = data.data.url
            this.orderNum = data.data.orderNum
            this.signature(data.data.signature, data.data.timestamp, data.data.nonceStr, data.data.url)
          }
        })
    },
    signature (signature, timestamp, nonceStr, url) {
      window.webComponent.config({
        signature: signature,
        appId: 'cli_a2dafca2d3799013',
        timestamp: timestamp,
        nonceStr: nonceStr,
        url: url,
        jsApiList: ['DocsComponent'],
        lang: 'zh'
      }).then((res) => {
        let that = this
        that.myComponent = window.webComponent.render(
          'DocsComponent',
          {
            src: that.url,
            height: '100%',
            minHeight: '500px',
            width: '100%'
          },
          document.querySelector('#feishu')
        )

        that.myComponent.config.setFeatureConfig({
          HEADER: {
            enable: true
          },
          // SIDEBAR: {
          //   borderSide: [true, true, true, true]
          // },
          DIRECTORY: {
            enable: true
          }
        })
      })
    }
  },
  mounted () {
    this.sign()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.feishu >>> .eWRrpX
  width: 0 !important
.feishu
  height: 100%
#feishu
  height: 95%
</style>



// WEBPACK FOOTER //
// src/pages/feishu/FeiShu.vue